@if (displayStep()) {
  <div class="status step-container my-2" [ngClass]="status$ | async">
    <div *ngrxLet="treatmentStep$ as treatmentStep" class="flex items-center">
      <ng-container *ngrxLet="appointment$ as appointment">
        <div class="header-wrapper" class="flex flex-1 items-center gap-6">
          <div class="flex basis-32 flex-col">
            <p class="mat-caption opaque">Treatment Step</p>
            <p class="mat-subtitle-2 w-32 truncate">
              {{ treatmentStep.name }}
            </p>
          </div>
          <pr-treatment-category-indicator
            *ngIf="treatmentCategory$ | async as category"
            displayOnly
            [category]="category"
          />
          @for (deposit of deposits$ | async; track $index) {
            <pr-timeline-deposit-notification
              [deposit]="deposit"
              [tooltipsEnabled]="true"
            />
          }
          <span class="flex-1"></span>
          <div class="flex flex-col">
            <button
              *ngIf="canSchedule$ | async"
              mat-flat-button
              color="primary"
              class="dense"
              ptElementTarget="enable-scheduling-button"
              matTooltip="Allow Front Desk to book this in"
              (click)="generateAppointment(treatmentStep)"
            >
              Enable Scheduling
            </button>
            <button
              *ngIf="canDisable$ | async"
              mat-stroked-button
              class="dense"
              ptElementTarget="disable-scheduling-button"
              matTooltip="Don't allow Front Desk to book this in"
              (click)="removeAppointment(treatmentStep)"
            >
              Disable Scheduling
            </button>
            <ng-container *ngIf="appointment">
              <div
                *ngIf="appointment | map: isUnscheduled"
                class="appointment-time unscheduled"
              >
                Unscheduled
              </div>

              <div
                *ngIf="(appointment | map: isUnscheduled) === false"
                class="appointment-time"
                [ngClass]="status$ | async"
              >
                {{ appointment | map: appointmentSummary }}
              </div>

              <button
                *ngIf="appointment | map: isBookable"
                mat-flat-button
                color="primary"
                class="dense appointment-action"
                (click)="selectAppointment(treatmentStep, appointment.ref)"
              >
                <ng-container
                  *ngIf="
                    appointment | map: isUnscheduled;
                    else rescheduleMessage
                  "
                >
                  <mat-icon>add</mat-icon> Book Now
                </ng-container>
                <ng-template #rescheduleMessage>
                  <mat-icon>keyboard_tab</mat-icon> reschedule
                </ng-template>
              </button>
            </ng-container>
          </div>
        </div>

        <pt-buttons-container>
          <div>
            <ng-content select=".header-buttons" />
          </div>

          <button mat-icon-button (click)="content.toggle()">
            <mat-icon>{{
              content.expanded ? 'expand_less' : 'expand_more'
            }}</mat-icon>
          </button>
        </pt-buttons-container>
      </ng-container>
    </div>

    <pt-collapsible #content [expanded]="expanded$ | async">
      <ng-template ptCollapsibleContent>
        <ng-content />
      </ng-template>
    </pt-collapsible>
  </div>
}
